import { useContext, useEffect, useState } from 'react'
import { Col, Row } from 'reactstrap'
import { IPLUS_WIZARD, StaticKYCContent, STEP_NUM } from '../IPlushelper'
import { useTranslation } from '../../../../store/context/TranslationContext';
import QRCode from 'qrcode.react';
import { FaCopy } from 'react-icons/fa';
import { StatusWithBadge } from '../../thirdParty/ondato/Ondato';
import { PreKYCInfo } from '../components';
import { doGET } from '../../../../util/HttpUtil';
import { DialogContext } from '../../../../store/context/DialogContext';
import clipboardCopy from 'clipboard-copy';
import { FaUserCheck } from 'react-icons/fa6';
import ButtonGroupNew from '../BusinessLiteForms/components/ButtonGroupNew';

const NoKYCRequired = ({ asLabel, completeApplication, loading }) => (
    <div className='d-flex align-items-center justify-content-between gap-3 flex-column'>
        <div className='rounded-circle p-3 mt-3' style={{ backgroundColor: "#e0f2fe" }}>
            <FaUserCheck size={60} color='#4a75ff' />
        </div>
        <h4 className='fw-semibold text-center fs-3'>KYC Verification not required.</h4>
        <p className='fs-5 fw-medium text-center'>Your information appears consistent so far. We'll notify you if verification materials are required later.</p>
        {!asLabel && <div className='w-100'>
            <ButtonGroupNew
                onNextClick={completeApplication}
                asLabel={false}
                loading={loading}
                hideBackButton
            />
        </div>}
    </div>
);

const KYCVerification = ({
    recordId,
    data,
    applicationForm,
    asLabel,
    ondatoStatus,
    setOndatoStatus,
    loading,
    setLoading,
    polling,
    setPolling,
    isAskForInfo,
    setStep,
    fetchDetail,
    isForEDD,
}) => {
    const { t } = useTranslation();
    const [showQRCode, setShowQRCode] = useState(false);
    const [qrCodeURL, setQRCodeURL] = useState('');
    let { showError, showMessage } = useContext(DialogContext);
    const [isKycVerificationRequired, setIsKycVerificationRequired] = useState(true);

    const fetchUbosForKycVerificationForEdd = async (editId) => {
        try {
            const response = await doGET(`/api/individual-lite/edd-info?id=${editId}`);
            if (response.status === 200) {
                const uboIdsForKYC = response?.data?.uboIdsForKYC;
                if (Array.isArray(uboIdsForKYC)) {
                    if (uboIdsForKYC.includes(data?.ubo_id)) {
                        setIsKycVerificationRequired(true);
                    } else {
                        setIsKycVerificationRequired(false);
                    }
                } else {
                    setIsKycVerificationRequired(false);
                }
            }
        } catch (error) {
            showError("Error", error)
        }
    }

    const handleCopyLink = () => {
        clipboardCopy(qrCodeURL);
        showMessage('Link copied to clipboard!');
    };

    const startPolling = () => {
        const intervalId = setInterval(() => {
            checkOndatoStatus();
        }, 20000);
        setPolling(intervalId);
    };

    useEffect(() => {
        if (isForEDD)
            fetchUbosForKycVerificationForEdd(recordId);
    }, [recordId, isForEDD]);

    useEffect(() => {
        return () => {
            if (polling) clearInterval(polling);
        };
    }, [])

    const checkOndatoStatus = async () => {
        try {
            const ondatoResponse = await doGET(`/api/ondato/form/status?id=${recordId}&refresh=true`);
            setOndatoStatus(ondatoResponse?.data);
            if (ondatoResponse?.data?.status === "Completed") {
                fetchDetail({ stepProp: { wizard: IPLUS_WIZARD.ThankYou } });
                if (polling)
                    clearInterval(polling);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const completeApplication = async () => {
        try {
            fetchDetail({ stepProp: { wizard: IPLUS_WIZARD.ThankYou } });
        } catch (error) {
            console.log(error);
        }
    }

    const requestLink = async () => {
        setLoading(true)
        try {
            const userAgent = navigator.userAgent.toLowerCase();
            const isMobile = /android|iphone/.test(userAgent);
            const response = await doGET(`/api/kyc/qr/url?form_id=${recordId}&ubo_id=${data?.ubo_id}`)
            if (isMobile) {
                window.location.href = response.data;
            } else {
                // Show QR code for desktop users
                setShowQRCode(true);
                setQRCodeURL(response.data);
                startPolling(); // Start
            }
        } catch (error) {
            showError(t(error));
        } finally {
            setLoading(false);
        }
    };

    if (!isKycVerificationRequired) {
        return <NoKYCRequired asLabel={asLabel} completeApplication={completeApplication} loading={loading} />
    }

    return (
        <div>
            {showQRCode && !asLabel ? (
                <Row>
                    <StaticKYCContent />
                    <Col className='col-sm-6' style={{ textAlign: 'center', marginBottom: '20px', marginTop: '20px' }}>
                        {ondatoStatus?.status == "Completed" ? null : <>
                            <p>{t("Scan this QR code with your mobile device to proceed:")}</p>
                            <QRCode value={qrCodeURL} size={256} level={"H"} includeMargin={true} />
                            <div style={{ marginTop: '20px' }}>
                                <p>{t("Can't scan the QR Code?")}
                                    <a href={qrCodeURL} target="_blank" rel="noopener noreferrer" style={{ marginLeft: '5px' }}>{t("Complete KYC on browser")}</a>
                                    <FaCopy onClick={handleCopyLink} style={{ cursor: 'pointer', marginLeft: '10px' }} />
                                </p>

                            </div>
                        </>
                        }

                        <div className='mt-4 d-flex w-100 align-items-center justify-content-center'>
                            {ondatoStatus?.status &&
                                <StatusWithBadge
                                    title="Status"
                                    status={ondatoStatus?.status ?? "Pending"}
                                />
                            }

                        </div>

                    </Col>
                </Row>
            ) : <div>
                <PreKYCInfo
                    asLabel={asLabel}
                    isAskForInfo={isAskForInfo}
                    loading={loading}
                    onNext={() => {
                        if (ondatoStatus?.status == "Completed") {
                            setStep({ wizard: IPLUS_WIZARD.ThankYou })
                        } else {
                            requestLink()
                        }
                    }}
                />
            </div>}
        </div>
    )
}

export default KYCVerification;
